import { getPourcentageIndicator } from '../../utils/getPourcentageIndicator';
import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import '../../css/dashboardListViewData.css';

const DashboardListViewData = ({ site, columnWidth }) => {

  if (!site) {
    return (
      <Box className='dashboard_table_row'>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.total_expenses_previous }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.purchase_price_previous }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.total_expenses_current }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.purchase_price_current }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.diff_expenses }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.diff_prices }}><Skeleton variant="text" width="100%" /></Box>
      </Box>
    );
  }

  const { pctChangeDisplay, pctColor, arrow } = getPourcentageIndicator(site?.total_expenses_previous, site?.total_expenses_current);
  const { pctChangeDisplay: pctChangeDisplayPrices, pctColor: pctColorPrices, arrow: arrowPrices } = getPourcentageIndicator(site?.total_purchase_price_previous, site?.total_purchase_price_current);

  return (
    <Box className='dashboard_table_row'>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'>{site?.name}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.total_expenses_previous, maxWidth: columnWidth.total_expenses_previous }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'right' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_expenses_previous) || '0,00 €'}
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.purchase_price_previous, maxWidth: columnWidth.purchase_price_previous }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'right' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_purchase_price_previous) || '0,00 €'}
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.total_expenses_current, maxWidth: columnWidth.total_expenses_current }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'right' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_expenses_current) || '0,00 €'}
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.purchase_price_current, maxWidth: columnWidth.purchase_price_current }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'right' }}>
          {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(site?.total_purchase_price_current) || '0,00 €'}
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ minWidth: columnWidth.diff_expenses, maxWidth: columnWidth.diff_expenses }}>
        <Typography className='tableBodyTypography' sx={{ color: pctColor, display: 'flex', alignItems: 'center', gap: '6px', justifySelf: 'flex-end' }}>
          <span style={{ fontSize: 12 }}>{arrow}</span>
          <span>{pctChangeDisplay}</span>
        </Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ minWidth: columnWidth.diff_prices, maxWidth: columnWidth.diff_prices }}>
        <Typography className='tableBodyTypography' sx={{ color: pctColorPrices, display: 'flex', alignItems: 'center', gap: '6px', justifySelf: 'flex-end' }}>
          <span style={{ fontSize: 12 }}>{arrowPrices}</span>
          <span>{pctChangeDisplayPrices}</span>
        </Typography>
      </Box>
    </Box>
  );
};

export default DashboardListViewData;